/**
 * @packageDocumentation
 * @module api.functional.items.stock_history
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { StockHistoryPoint } from "../../../structures/StockHistoryPoint";

/**
 * @controller ItemController.getStockHistory
 * @path GET /items/:id/stock-history
 * @accessor api.functional.items.stock_history.getStockHistory
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getStockHistory(
  connection: IConnection,
  id: string,
  query: getStockHistory.Query,
): Promise<getStockHistory.Output> {
  return PlainFetcher.fetch(connection, {
    ...getStockHistory.METADATA,
    template: getStockHistory.METADATA.path,
    path: getStockHistory.path(id, query),
  });
}
export namespace getStockHistory {
  export type Query = {
    from: string;
    to: string;
  };
  export type Output = StockHistoryPoint[];

  export const METADATA = {
    method: "GET",
    path: "/items/:id/stock-history",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string, query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = `/items/${encodeURIComponent(id?.toString() ?? "null")}/stock-history`;
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
